import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, throwError, Subscription } from 'rxjs';

import { catchError, map, mergeMap, switchMap, withLatestFrom, distinctUntilChanged } from 'rxjs/operators';

import { SettingsWorkflowsRequests } from './workflows.requests';
import * as fromStore from './workflows.state';
import * as fromActions from './workflows.actions';

import * as Objects from '@core/objects';

@Injectable()
export class SettingsWorkflowsEffects {

    constructor(private actions$: Actions, private store$: Store<fromStore.SettingsWorkflows>, private requests: SettingsWorkflowsRequests) {}


    public loadWorkflows$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadWorkflows>(fromActions.SettingsWorkflowsActionType.LoadWorkflows),
        switchMap((action) => {
            return this.requests.loadWorkflows$().pipe(
                map((wfs: Objects.Workflow[]) => {
                    return new fromActions.LoadWorkflowsSuccess(wfs);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadWorkflowsError(err));
                })
            );
        })
    ));

    public loadWorkflowTransitions$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTransitions >(fromActions.SettingsWorkflowsActionType.LoadTransitions),
        switchMap((action) => {
            return this.requests.loadWorkflowTransitions$(action.workflowId).pipe(
                map((wfTrx: Objects.WorkflowTransition[]) => {
                    return new fromActions.LoadTransitionsSuccess(wfTrx);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadTransitionsError(err));
                })
            );
        })
    ));

    public saveWorkflowTransitions$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SaveTransitions>(fromActions.SettingsWorkflowsActionType.SaveTransitions),
        mergeMap((action) => {
            return this.requests.save$(action.transitions, action.id).pipe(
                map((wfTrxUpdated: Objects.WorkflowTransition[]) => {
                    return new fromActions.SaveTransitionsSuccess(wfTrxUpdated);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.SaveTransitionsError(err));
                })
            );
        })
    ));

    // update workflow list, to get it with its new initial status.
    public saveTransitionsSucces$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SaveTransitionsSuccess>(fromActions.SettingsWorkflowsActionType.SaveTransitionsSuccess),
        switchMap((action) => {
                return [new fromActions.LoadWorkflows()];
        })
    ));


}